<template>
  <div class="completed">
    <Header propsTitle="회원가입"/>

    <div class="container height-fix">
      <div class="page-inner">
        <br/><br/>
        <h1 class="step-title">
          <img src='@/assets/images/common/img_completed.png' alt="" />
        </h1>
        <h4 class="step-sub-title text-center">회원가입 신청 완료</h4>
        <p class="step-sub-content text-center">
          회원가입 신청이 완료 되었습니다.
        </p>
        <p class="step-sub-content text-center">
          가입승인 완료 여부를 알림톡으로<br/>
          안내해드리겠습니다.
        </p>
      </div>
      <div class="bottom-btn">
        <v-btn color="mainColorDark" class="btn-text-white mb-3" x-large depressed block @click="handleClose">닫기</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../commonComp/WS-Header.vue";

export default {
  components: { Header },
  methods: {
    handleClose() {
      // 안드로이드
      if (window.KakaoWebViewInterface) {
        window.KakaoWebViewInterface.close();
        return;
      }

      // iOS
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.close) {
        window.webkit.messageHandlers.close.postMessage(null);
        return;
      }

      // 기타 (구버전)
      if (window.KakaoWebViewJavascriptBridge) {
        window.KakaoWebViewJavascriptBridge.close();
        return;
      }

      if (window.KakaoPop) {
        window.KakaoPop.close();
        return;
      }

      // 보안정책 등 인앱 닫기가 안되는 경우 홈 화면으로 이동
      this.$router.push({ path: '/home' }).catch(() => {});

    }
  },
};
</script>
